import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import { Create, Form, useForm } from "@pankod/refine-antd";
import axios from "axios";

import { FormList } from "./form";
import { IStore } from "interfaces";
import { dataProvider } from "dataProvider";

export const StoreCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IStore>({
    // warnWhenUnsavedChanges is set to false because, otherwise,
    // redirect will trigger a "Leave Page" pop up which we don't want
    // (even after order has been saved).
    warnWhenUnsavedChanges: false,
  });
  const { list } = useNavigation();

  const emailContract = async (variables: any) => {
    // Register/create store.
    await dataProvider.create({
      resource: "stores",
      variables,
      metadata: undefined,
    });

    // Send email
    const form = formProps.form;
    if (form) {
      const managementEmail = form.getFieldValue("email");
      const representativeEmail = form.getFieldValue("representativeEmail");
      const retailerName = form.getFieldValue("title");
      const retailerLegalName = form.getFieldValue("legalTitle");
      const representativeName = form.getFieldValue("representativeName");
      const { country, city, address2, postal_code } =
        form.getFieldValue("address");
      const addressParts = (address2 as string).split(",");
      const address = addressParts[0] + addressParts[1];
      const params = {
        managementEmail,
        representativeEmail,
        retailerName,
        retailerLegalName,
        representativeName,
        country,
        city,
        postalCode: postal_code,
        address,
      };
      await axios.post(
        "https://carrybags-2023-3c04ef5ca86e.herokuapp.com/api/v1/partner/email-contract",
        params
      );
      list("stores");
    }
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={
          {
            // isActive: true,
          }
        }
        onFinish={(values) => emailContract(values)}
      >
        <FormList formProps={formProps} type="create" />
      </Form>
    </Create>
  );
};
